import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { FcpIconModule } from '../fcp-icon';
import { FcpRadioComponent } from './fcp-radio.component';

@NgModule({
    declarations: [FcpRadioComponent],
    imports: [FcpIconModule, CommonModule],
    exports: [FcpRadioComponent]
})
export class FcpRadioModule {}
